var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPFwoman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114.279 114.279",
    style: {
      enableBackground: "new 0 0 114.279 114.279"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3947 -0.9188 0.9188 0.3947 6.9937 106.2129)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDECC"
    },
    cx: 84.107,
    cy: 47.799,
    rx: 7.317,
    ry: 4.231
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF690F"
    },
    d: "M15.989,84.083c-2.123-2.848-0.711-5.583,2.494-7.394 c4.619-2.612,3.463-6.694-2.235-9.305c-5.698-2.61-6.774-10.451-0.769-14.774c6.006-4.323,7.543-7.793,3.306-13.67 c-4.237-5.877-1.059-15.83,5.41-17.134c6.469-1.304,5.493-2.072,6.873-7.245c2.401-8.996,12.755-15.862,18.298-9.985 c7.928-9.703,25.751-2.295,28.978,6.681c3.419,9.512,6.514,9.417,11.597,12.045c5.083,2.628,6.743,14.486,2.889,19.431 c-5.1,6.541-2.293,9.457,3.944,12.558c6.236,3.101,4.71,7.677-0.256,10.246c-4.966,2.567-8.048,7.154-3.428,9.766 c3.384,1.913,4.382,4.639,3.077,8.803C89.988,103.839,33.139,107.093,15.989,84.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDECC"
    },
    d: "M66.808,73.832c-0.198,0.313-19.745,0.624-19.962,0.932 c-6.139,8.759-19.404,12.596-29.95,14.954c-10.497,2.347-10.903,15.68-10.919,24.56h102.324c-0.016-8.88-0.211-22.165-10.919-24.56 C86.674,87.323,72.632,82.989,66.808,73.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDECC"
    },
    d: "M67.391,55.129v25.117c-5.639,7.412-14.865,7.155-20.504,0 V55.129C46.887,41.566,67.391,41.566,67.391,55.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F7C5AA"
    },
    d: "M67.391,55.129v16.816c-3.88,3.035-7.619,4.735-10.252,4.735 s-6.373-1.701-10.252-4.735V55.129C46.887,41.566,67.391,41.566,67.391,55.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDECC"
    },
    d: "M57.139,72.503c-6.674,0-20.775-10.494-25.135-25.524 c-4.401-15.176,3.889-36.944,25.135-36.944c21.247,0,29.537,21.767,25.135,36.944C77.915,62.009,63.814,72.503,57.139,72.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF386A"
    },
    d: "M49.099,57.372c3.401-3.293,6.054-0.823,8.04-0.823 c1.986,0,4.639-2.47,8.04,0.823C63.352,66.056,51.523,66.322,49.099,57.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M50.143,57.821c1.859-0.476,11.329-0.572,13.992-0.104 C61.936,61.766,52.004,61.531,50.143,57.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF386A"
    },
    d: "M49.099,57.372c3.401-3.293,6.054-0.823,8.04-0.823 c1.986,0,4.64-2.47,8.04,0.823C59.979,59.934,52.599,58.737,49.099,57.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#86BCEB"
    },
    d: "M19.817,114.279c10.919-12.724,26.538-2.11,36.693-2.11 c10.156,0,25.614-12.221,36.693,2.11H19.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF690F"
    },
    d: "M78.786,61.817c-5.121,9.614,20.594-24.301-1.557-46.802 C64.004,1.58,42.087,2.522,33.522,17.437c4.192,6.348,13.161,12.018,23.672,11.799c17.868-0.373-1.385,10.868,13.17,12.785 c10.6,1.396,8.531,3.318,3.35,9.113C70.086,55.192,71.114,60.476,78.786,61.817z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3947 -0.9188 0.9188 -0.3947 -1.1945 94.8102)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDECC"
    },
    cx: 30.634,
    cy: 47.799,
    rx: 7.317,
    ry: 4.231
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF690F"
    },
    d: "M43.458,17.74c-1.993,8.191,1.319,14.569-5.437,15.37 c-8.791,1.042-4.606,6.565-5.285,13.348C27.883,40.41,26.318,13.533,43.458,17.74z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPFwoman);
export default __webpack_public_path__ + "static/media/PFwoman.f6dda7de9d60c4612d59e08fefe6585a.svg";
export { ForwardRef as ReactComponent };